export default {
    data: () => ({
        translations: {
            title: {
                el: "Ωράριο Λειτουργίας",
                en: "Hours of Operations",
                it: "Orari di apertura"
            },
            start: {
                el: "",
                en: "Start Time",
                it: ""
            },
            end: {
                el: "",
                en: "End Time",
                it: ""
            },
            cancel: {
                el: "Κλείσιμο",
                en: "Cancel",
                it: "Chiudi"
            },
            accept: {
                el: "",
                en: "Accept",
                it: ""
            }
        }
    })
};
